import { Show, createSignal, onMount } from "solid-js";

import "./LogoLoading.css";

export function LogoLoading() {
  const capitalizeWords = (str: string) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const duration = 1000; // 动画持续时间，单位毫秒
  let animateRef: HTMLDivElement | undefined;
  const [loading, setLoading] = createSignal(false);
  const [animate, setAnimate] = createSignal("");

  onMount(() => {
    setAnimate("logo-loading__animate_fadeOut");
    setTimeout(() => setLoading(true), duration);
  });

  return (
    <Show when={!loading()} fallback={<></>}>
      <div
        class="fixed inset-0 z-[99999] flex h-full max-h-screen w-full items-center justify-center bg-black"
        ref={animateRef}
      >
        {/* <Icon
          name="close"
          class={clsx(
            "text-general-white z-10",
            isMobile() ? "size-[8px]" : "size-[10px]",
          )}
          wrapperClass={clsx(
            "bg-[rgba(255,255,255,0.1)] flex-center cursor-pointer absolute ",
            isMobile()
              ? "size-[24px] rounded-[5px] top-[13.5px] right-[14px]"
              : "size-[28px] rounded-[6px] top-[24px] right-[20px]",
          )}
          onClick={(e) => {
            e.stopPropagation();
            setLoading(true);
          }}
        /> */}
        <div class={`scale-60 ${animate()}`}>
          <img
            src={`/${__APP_NAME__}/images/logo/logo.png?v=${__APP_VERSION__}`}
            alt={`${capitalizeWords(__APP_NAME__)} - Logo`}
          />
        </div>
      </div>
    </Show>
  );
}
